import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

const inputCls = "w-full bg-[#070709] border border-[#232530] px-4 py-2.5 text-[#ede8e1] font-light placeholder:text-[#57534e] focus:border-[#581313] focus:outline-none transition-colors text-sm";

export const ImageUpload = ({ value, onChange, testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
      toast.success("Image sealed in the Vault.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex flex-col sm:flex-row gap-3">
        <input value={value || ""} onChange={(e) => onChange(e.target.value)}
          placeholder="Image URL — or upload from your machine"
          className={`${inputCls} flex-1`} data-testid={`${testid}-input`} />
        <button type="button" onClick={() => ref.current?.click()} disabled={busy}
          data-testid={`${testid}-upload-button`}
          className="flex items-center justify-center gap-2 bg-[#14151b] hover:bg-[#232530] disabled:opacity-50 text-[#ede8e1] border border-white/10 font-mono text-xs uppercase tracking-widest px-5 py-2.5 transition-colors shrink-0">
          <Upload size={14} /> {busy ? "Sealing…" : "Upload"}
        </button>
        <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif"
          onChange={upload} className="hidden" data-testid={`${testid}-file-input`} />
      </div>
      {value && (
        <img src={value} alt="Preview" data-testid={`${testid}-preview`}
          className="h-24 w-auto object-cover border border-[#232530]" />
      )}
    </div>
  );
};
